import { render } from "./Fatura.vue?vue&type=template&id=25c17a2b&scoped=true"
import script from "./Fatura.vue?vue&type=script&lang=js"
export * from "./Fatura.vue?vue&type=script&lang=js"

import "./Fatura.vue?vue&type=style&index=0&id=25c17a2b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c17a2b"]])

export default __exports__